import React, { Component } from 'react';

import CardJob from './job-card.component';

// styles & icons
import { Row, Col } from 'react-bootstrap';
import { Paper, Button } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import workIcon from '../../../images/work.svg';

export default class Jobs extends Component {
    constructor() {
        super();
        this.state = []
    }
    render() {
        return (
            <div>
                <Paper className="p-3 mt-4" style={{ borderRadius: '0px' }}>
                    <Row >
                        <Col md={12}>
                            <Row className="m-0 mb-3 align-items-center">
                                <Col className="text-left p-0">
                                    <h6 className="bold mb-0">
                                        <span ><img src={workIcon} alt="icon" className="pr-3 pb-1" /></span>
                                                    Saved Job posts
                                                </h6>
                                </Col>
                                <Col className="text-right">
                                    <p style={{ fontSize: '14px' }} className="mb-0"> Sort by: <span className="text-orange">Latest </span> <ExpandMoreIcon style={{ fontSize: '1.5rem' }} /></p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div>
                        <CardJob />
                        <CardJob />
                        <CardJob />
                    </div>
                </Paper>
            </div>
        )
    }
}